<template>
    <div>
      <SubTitle text="Administrar ordenes">
             <el-button v-on:click="addSocs" size="small"
                    class="default right ml-1">
                BUSCAR SOC(s)
            </el-button>
      </SubTitle>

      <div class="card-section">
        <p v-if="list.length < 1" class="msg-not-sector">NINGUNA SOC INGRESADA</p>
        <el-table
          v-else
          :data="suborderPaged"
          ref="tableSuborder"
          @selection-change="handleSelectionChange"
          @filter-change="applyFilter"
          row-class-name="row-medium">
          <el-table-column
            prop="sectors"
            label="Estado"
            column-key="sector"
            :filters="filterSectorData">
            <template slot-scope="scope">
              <span v-if="haveSplits(scope.row)"
                    class="status-soc">
                <i class="fas fa-cubes"/>Contiene splits
              </span>
              <span v-else-if="notFound(scope.row)"
                    class="status-soc">
                <i  class="fas fa-question"/>No encontrado
              </span>
              <span v-else-if="notPlannable(scope.row)"
                    class="status-soc">
                <i class="fas fa-times"/>No planificable
              </span>
              <span v-else>
                Encontrado
              </span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            label="SOC"
            prop="suborder"/>
          <el-table-column
            sortable
            label="Vol."
            prop="volume"
            :formatter="formatVolume"
            column-key="volume"/>
          <el-table-column
            sortable
            label="Tipo"
            prop="document_type_name"
            column-key="document"
            :filters="filterDocumentTypeData">
          </el-table-column>
          <el-table-column
            sortable
            label="Localidad"
            prop="locality"
            column-key="locality"
            :filters="filterLocalityData">
          </el-table-column>
          <el-table-column
            sortable
            label="Estado"
            prop="last_state_name"
            column-key="states"
            align="center"
            :filters="filterStateData">
            <template slot-scope="scope">
              <span v-if="[5, 6].includes(scope.row.last_state)"
                    class="tag-red">
                 {{scope.row.last_state_name}}
              </span>
              <span v-else>
                {{scope.row.last_state_name}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            label="Tamaño"
            prop="package_type_name"
            column-key="package"
            align="center"
            :filters="filterPackageTypeData">
            <template slot-scope="scope">
              <span v-if="scope.row.package_type_name === 'NF'"
                    class="tag-red">
                 no informado por TRL
              </span>
              <span v-else>
                {{scope.row.package_type_name}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Acciones"
            width="80"
            v-slot="scope">
              <a class="el-icon-delete delete-soc-icon"
                 @click="deleteSuborder(scope.row.suborder)"/>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          v-if="this.suborders.length > 0"
          layout="sizes, total, prev, pager, next"
          :page-size="this.pageSize"
          :page-sizes="this.pageSizes"
          :pager-count="5"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :total="this.suborders.length">
        </el-pagination>
      </div>

      <el-button v-on:click="confirmSocs" :disabled="list.length < 1" size="large"
        class="default right ml-1 mt-1">
        CONFIRMAR
      </el-button>

      <SuborderAdd ref="dialogAdd"
                   v-model="list"
                   :sectors="sectors"/>


    <el-dialog title="Información" :visible.sync="dialogVisible">
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="default"
                   @click="dialogVisible = false">Cerrar</el-button>
      </span>
    </el-dialog>

    </div>
  </template>

<script>
import moment from 'moment';
import GoGeo from '../planningv4/suborder/GoGeo.vue';
import GetTO from '../planningv4/suborder/GetTO.vue';
import SuborderAdd from '../planningv4/suborder/Add.vue';
import LpnAdd from '../planningv4/suborder/Lpn.vue';
import SuborderSplit from '../planningv4/suborder/Split.vue';
import ActionSimple from '../planningv4/suborder/action/Simple.vue';
import SubTitle from '../base/SubTitle.vue';
import GoogleMapsLoader from '../maps/config';
import ActionMultiple from '../planningv4/suborder/action/Multiple.vue';
import { apiRequest } from '../../../backend/vue-axios/axios';


export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    dataToGetTO: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  name: 'TableSPTG',
  components: {
    GoGeo,
    GetTO,
    SubTitle,
    SuborderAdd,
    LpnAdd,
    ActionSimple,
    SuborderSplit,
    ActionMultiple,
  },
  data() {
    return {
      checked: [],
      google: null,
      pageSize: 100,
      pageSizes: [10, 20, 30, 40, 50, 100],
      currentPage: 0,
      setSector: [],
      totalChecked: 0,
      list: this.value,
      filterPkg: [],
      filterDoc: [],
      filterState: [],
      filterDateAt: [],
      filterSector: [],
      filterLocality: [],
      optionsToForce: [],
      filterCentroide: false,
      exportCount: -1,
      codePlanning: Math.floor(Math.random() * (90000 - 10000)) + 10000,
      dialogVisible: false,
      dialogMsg: '',
    };
  },
  mounted() {
    const date = moment().format('YYMMDDHHmm');
    const historyCode = this.updateCode(date);
    this.$emit('updateCode', historyCode);
    GoogleMapsLoader.load((google) => {
      this.google = google;
    });
  },
  watch: {
    list() {
      if (this.list.length === 0) this.currentPage = 0;
      this.$emit('input', this.list);
    },
    checked() {
      this.totalChecked = this.checked.length;
    },
  },
  filters: {
    len(data) {
      return data.filter(s => s.splits).length;
    },
    existNotFound(data) {
      return data.filter(s => s.current_do === -1).length < 1;
    },
  },
  methods: {
    confirmSocs() {
      this.dialogVisible = true;
      this.dialogMsg = 'Procesando ordenes...';

      const { list } = this;
      const listSOC = [];
      /*
          Se validan las ordenes.
          Se crea un arreglo con las ordenes que seran enviadas
        */
      for (let index = 0; index < list.length; index++) {
        const soc = list[index];
        const notFound = this.notFound(soc);
        if (notFound) {
          console.log(soc.suborder);
          this.dialogMsg = 'La operación no puede ser procesada. Hay ordenes no válidas..';
          return;
        }
        listSOC.push(soc.suborder);
      }

      // Se procede a enviar las ordenes
      this.sendSubOrdersToLocation(listSOC);
    },
    sendSubOrdersToLocation(listSoc) {
      const lSoc = listSoc;

      new Promise((resolve, reject) => {
        apiRequest({
          module: 'location',
          service: 'suborder_locations_edit',
          params: {
            suborders: lSoc,
          },
        }).then((response) => {
          const result = {
            success: [],
            not_found: [],
          };

          /* if (response.data.hasOwnProperty('update')){
              response.data.update.forEach( suborder => {
                result.success.push(suborder)
              },result);
            }

            if (response.data.hasOwnProperty('suborders')){
              response.data.suborders.forEach( suborder => {
                result.success.push(suborder)
              },result);
            } */

          if (response.data.hasOwnProperty('no_found')) {
            response.data.no_found.forEach((suborder) => {
              result.success.push(suborder);
            }, result);
          }

          let msg = 'Las ordenes fueron procesadas con éxito.';

          if (result.not_found.length > 0) {
            msg += `Las siguientes ordenes no fueron encontradas: ${result.not_found.join(' ')}` + '.';
          }
          this.dialogMsg = msg;
          this.list = [];
          resolve(result);
        }).catch((e) => {
          this.dialogMsg = 'Hay un error, favor vuelva a intentar.';
          reject('Hay un error, favor vuelva a intentar.');
        });
      });
    },
    addSocs() {
      this.$refs.dialogAdd.open();
    },
    getSectorColor(id) {
      return this.sectors.find(s => s.id === id).color;
    },
    pkgTypeName(soc) {
      return soc.package_type_name === 'NF' ? 'no informado por TRL' : soc.package_type_name;
    },
    updateCode(date) {
      this.exportCount = this.exportCount + 1;
      return `${this.codePlanning}_${this.exportCount}_${date}`;
    },
    inCentroide() {
      this.currentPage = 0;
      this.filterCentroide = !this.filterCentroide;
    },
    checkFilterInCentroide() {
      this.filterCentroide = this.suborders.filter(s => s.geostate === 4).length > 0;
    },
    getSplits() {
      this.$refs.dialogSplit.openModal();
    },
    async copyNotFound() {
      const socs = this.list.filter(s => this.notFound(s)).map(s => s.suborder);
      const base = `Se han copiado ${socs.length}`;
      const countText = socs.length > 1 ? `${base} elementos` : `${base} elemento`;
      await navigator.clipboard.writeText(socs.join('\r\n')).then(
        this.$notify.success({ title: countText }),
      );
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1;
    },
    handleSizeChange(val) {
      this.currentPage = 0;
      this.pageSize = val;
    },
    applyFilter(filters) {
      this.currentPage = 0;
      if (filters.package) this.filterPkg = filters.package;
      if (filters.states) this.filterState = filters.states;
      if (filters.sector) this.filterSector = filters.sector;
      if (filters.document) this.filterDoc = filters.document;
      if (filters.locality) this.filterLocality = filters.locality;
      if (filters.requested) this.filterDateAt = filters.requested;
    },
    getSectorById(soc) {
      return this.sectors.filter((sector) => {
        if ((sector.packageTypes.map(pt => pt.id).includes(soc.package_type_id)
            || (sector.packageTypes.length > 0 && soc.package_type_name === 'NF'))
            && this.validateZone(sector, soc)
            && !(this.haveSplits(soc) || this.notPlannable(soc))) {
          // eslint-disable-next-line no-param-reassign
          soc.forceSector = null;
          return true;
        }
        return false;
      });
    },
    validateZone(sector, soc) {
      if (sector.mode === 'POLÍGONO') {
        const coordinate = new this.google.maps.LatLng(parseFloat(soc.lat), parseFloat(soc.lng));
        const polygon = new this.google.maps.Polygon({ path: sector.polygon });
        return this.google.maps.geometry.poly.containsLocation(coordinate, polygon);
      }
      return sector.localities.map(l => l.name).includes(soc.locality);
    },
    getSectorForce(soc) {
      const sectors = this.sectors.filter(s => s.id === soc.forceSector);
      // eslint-disable-next-line no-param-reassign
      if (sectors.length === 0) soc.forceSector = null;
      return sectors;
    },
    getSectorOfSuborder(soc) {
      // eslint-disable-next-line no-param-reassign
      soc.sectors = this.getSectorForce(soc);
      this.$notify.success({ title: 'Sector asignado con éxito' });
    },
    formatDate(row) {
      // const date = moment.utc(row.requested_at).locale('es').format('D MMM');
      const date = moment.utc(row.requested_at).format('DD/MM/YY');
      return ['01/01/01', '01/01/70'].includes(date) ? '' : date;
    },
    formatVolume(row) {
      return row.volume ? `${row.volume.toFixed(2)} mt³` : '';
    },
    notFound(soc) {
      return soc.current_do === -1;
    },
    haveSplits(soc) {
      return soc.splits;
    },
    notPlannable(soc) {
      return [5, 6].includes(soc.last_state);
    },
    handleSelectionChange(val) {
      this.checked = val.map(s => s.suborder);
    },
    deleteSocs(option) {
      if (option === 0) {
        this.deleteAllSelected();
      } else if (option === 1) {
        this.deleteAllPaginated();
      }
    },
    deleteAllPaginated() {
      this.$confirm('¿Está seguro que desea eliminar las socs paginadas?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list
          .filter(s => this.suborders
            .findIndex(val => val.suborder === s.suborder) === -1);
        this.checked = [];
        this.clearFilter();
        this.verifyPaged();
        this.$notify.success({ title: 'Subordenes eliminadas con éxito' });
      }).catch(() => {});
    },
    deleteAllSelected() {
      this.$confirm('¿Está seguro que desea eliminar las socs seleccionadas?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list
          .filter(s => this.checked
            .findIndex(val => val === s.suborder) === -1);
        this.checked = [];
        this.clearFilter();
        this.verifyPaged();
        this.$notify.success({ title: 'Subordenes eliminadas con éxito' });
      }).catch(() => {});
    },
    deleteSuborder(soc) {
      this.$confirm('¿Está seguro que desea eliminar la soc?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list.filter(s => s.suborder !== soc);
        if (this.list.length === 0) this.checked = [];
        this.verifyPaged();
        this.$notify.success({ title: 'Suborden eliminada con éxito' });
      }).catch(() => {});
    },
    verifyPaged() {
      if (this.suborderPaged.length === 0
          && this.currentPage > 0) this.currentPage = this.currentPage - 1;
    },
    clearFilter() {
      this.filterPkg = [];
      this.filterDoc = [];
      this.filterState = [];
      this.filterDateAt = [];
      this.filterSector = [];
      this.filterLocality = [];
      this.filterCentroide = false;
      if (this.$refs.tableSuborder) this.$refs.tableSuborder.clearFilter();
    },
    getOptionsToForce() {
      this.$refs.cascadeSuborder.panel.activePath = [];
      const children = this.sectors.map(s => ({ value: s.id, label: s.name }));
      this.optionsToForce = [{
        value: 'selected',
        label: `seleccionadas (${this.totalChecked})`,
        disabled: this.totalChecked < 1,
        children,
      }, {
        value: 'paginated',
        label: `paginadas (${this.suborders.length})`,
        disabled: this.suborders.length < 1,
        children,
      }];
    },
    SetSectorMassive() {
      if (this.setSector[0] === 'selected') {
        this.setMassive(this.checked, this.setSector[1]);
      } else if (this.setSector[0] === 'paginated') {
        this.setMassive(this.suborders.map(s => s.suborder), this.setSector[1]);
      }
    },
    setMassive(socs, sectorId) {
      this.list.forEach((s) => {
        if (socs.includes(s.suborder)
            && !(this.haveSplits(s) || this.notFound(s) || this.notPlannable(s))) {
          // eslint-disable-next-line no-param-reassign
          s.forceSector = sectorId;
          // eslint-disable-next-line no-param-reassign
          s.sectors = this.getSectorForce(s);
        }
      });
      this.setSector = [];
      this.$refs.tableSuborder.clearSelection();
      this.$notify.success({ title: 'Sector asignado con éxito' });
    },
    getErrors() {
      const err = [];
      const countWithoutSector = this.list.filter(s => s.sectors.length < 1).length;
      const countTooManySector = this.list.filter(s => s.sectors.length > 1).length;
      const countExistSector = this.list.filter(s => s.sectors.length === 1).length;
      if (countWithoutSector > 0) err.push(`Hay ${countWithoutSector} soc sin sector`);
      if (this.list.length < 1) err.push('No se ha ingresado ninguna soc');
      else
      if (countExistSector < 1) err.push('Ningun soc tiene sector asociado');
      if (countTooManySector > 0) err.push(`Hay ${countTooManySector} soc con más de un sector`);
      this.$emit('errors', err);
      this.$emit('countSocWithoutSector', countWithoutSector);
    },
  },
  computed: {
    optionsToDelete() {
      return [{
        name: `seleccionadas (${this.totalChecked})`,
        disabled: this.totalChecked < 1,
      }, {
        name: `paginadas (${this.suborders.length})`,
        disabled: this.suborders.length < 1,
      }];
    },
    disabledMassiveOptions() {
      return this.totalChecked < 1 && this.suborders.length < 1;
    },
    filterEnable() {
      return this.filterPkg.length > 0
            || this.filterDoc.length > 0
            || this.filterState.length > 0
            || this.filterSector.length > 0
            || this.filterDateAt.length > 0
            || this.filterLocality.length > 0
            || this.filterCentroide === true;
    },
    suborderPaged() {
      return this.suborders
        .slice(this.currentPage * this.pageSize, (this.currentPage + 1) * this.pageSize);
    },
    suborders() {
      this.getErrors();
      return this.list.map((soc) => {
        const sectors = this.getSectorForce(soc).length > 0
          ? this.getSectorForce(soc) : this.getSectorById(soc);
        return Object.assign(soc, { sectors });
      }).filter((s) => {
        const filter = [];
        if (this.filterState.length > 0) filter.push(this.filterState.includes(s.last_state));
        if (this.filterPkg.length > 0) filter.push(this.filterPkg.includes(s.package_type_name));
        if (this.filterLocality.length > 0) filter.push(this.filterLocality.includes(s.locality));
        if (this.filterDoc.length > 0) filter.push(this.filterDoc.includes(s.document_type_name));
        if (this.filterDateAt.length > 0) filter.push(this.filterDateAt.includes(s.requested_at));
        if (this.filterSector.length) {
          const filterThisSector = [];
          if (s.sectors.length > 0) {
            s.sectors.forEach((thisSector) => {
              filterThisSector.push(this.filterSector.includes(thisSector.name));
            });
          } else if (this.filterSector.includes('Sin sector')) {
            filterThisSector.push(true);
          } else {
            filterThisSector.push(false);
          }
          filter.push(filterThisSector.reduce((acum, el) => acum || el, false));
        }
        if (this.filterCentroide) filter.push(s.geostate === 4);
        return filter.reduce((acum, el) => acum && el, true);
      });
    },
    filterSectorData() {
      this.getErrors();
      return this.sectors.slice().map(sector => ({ text: sector.name, value: sector.name }))
        .concat({ text: 'Sin sector', value: 'Sin sector' })
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterStateData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const lastStateName = pt.last_state < 0 ? '(Vacío)' : pt.last_state_name;
          return ({ text: lastStateName, value: pt.last_state });
        })
        .filter((pt, i, acum) => acum
          .findIndex(t => t.value === pt.value) === i);
    },
    filterPackageTypeData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          // eslint-disable-next-line no-nested-ternary
          const packageTypeName = this.notFound(pt)
            ? '(Vacío)' : this.pkgTypeName(pt);
          return ({ text: packageTypeName, value: pt.package_type_name });
        })
        .filter((pt, i, acum) => acum
          .findIndex(t => t.value === pt.value) === i);
    },
    filterLocalityData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const locality = pt.locality === '' ? '(Vacío)' : pt.locality;
          return ({ text: locality, value: pt.locality });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterDocumentTypeData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const document = pt.document_type_name === '' ? '(Vacío)' : pt.document_type_name;
          return ({ text: document, value: pt.document_type_name });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterRequestedAtData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const date = moment.utc(pt.requested_at).format('DD/MM/YY');
          const requestedAt = ['01/01/01', '01/01/70'].includes(date) ? '(Vacío)' : date;
          return ({ text: requestedAt, value: pt.requested_at });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.value > a.value ? -1 : 1));
    },
  },
};
</script>

  <style lang="scss" scoped>
    .left { float: left; }
    .right { float: right; }
    .card-section {
      border-radius: 3px;
      border: 1px solid #eaeaea;
      .msg-not-sector {
        color: $fb-grey-light-70;
        font-size: 12px;
        font-weight: 700;
        margin: 20px 12px;
        text-align: center;
      }
      .card-navbar {
        padding: 0 2px;
        font-size: 13px;
        text-align: left;
        margin-bottom: 10px;
        .right { float: right; }
        border-bottom: 1px solid #eaeaea;
      }
    }
    .sector-tag {
      color: white;
      margin-right: 5px;
      padding: 2px 10px;
      border-radius: 3px;
    }
    .action-socs-btn, .action-sub-btn {
      border: none;
      i { font-weight: 900; }
      span { margin-left: 7px; }
    }
    .action-socs-btn {
      padding: 6px 12px;
      margin: 0 0 5px 10px;
    }
    .action-sub-btn {
      padding: 0;
      color: $fb-green;
      margin: 10px 12px 0 12px;
      text-decoration: underline;
      background-color: white !important;
    }
    #disable-link-delete, #disable-link-clean { background-color: white !important; }
    .delete-soc-icon {
      margin: 7px 0;
      font-size: 14px;
      cursor: pointer;
    }
    .delete-soc-icon:hover { color: $fb-red-light-20; }
    .select-sectors {
      margin-right: 16px;
      width: 300px !important;
    }
    .tag-red {
      color: white;
      height: 19px;
      padding: 0 10px;
      font-size: 12px;
      line-height: 1.6;
      text-align: center;
      border-radius: 15px;
      display: inline-block;
      background-color: $fb-red-light-20;
    }
    .status-soc {
      width: 15px;
      display: inline-block;
      .fa-cubes {
        color: $fb-amber;
        margin-right: 4px;
      }
      i { vertical-align: middle; }
      .fa-times { margin-right: 8px; }
      .fa-question { margin-right: 7px; }
      .fa-times, .fa-question { color: $fb-red-light-20; }
    }
    .circle-color {
      width: 12px;
      height: 12px;
      border-radius: 20px;
      display: inline-block;
      margin: 0 4px -1px -10px;
    }
    .label-set-sector {
      color: #555;
      font-size: 10px;
      font-weight: 500;
      margin: 12px 8px 0 8px;
    }

    .mt-1{
      margin-top:0.50rem;
    }
  </style>
